import { RegvarModel } from './index';
export class RegvarBooleanModel extends RegvarModel {
    setValue(value, options) {
        const valueType = typeof value;
        if (valueType === 'boolean') {
            return super.setValue(value, options);
        }
        if (!value) {
            return super.setValue(null, options);
        }
        throw new Error(`Expected a boolean value but got "${value}" (${valueType}).`);
    }
}
